module.exports = __webpack_public_path__ + "images/volvo_small7830059e0a0aface6cffc33a22882169.png";